import { render, staticRenderFns } from "./Sub_DepartmentCategory.vue?vue&type=template&id=1626a6b7"
import script from "./Sub_DepartmentCategory.vue?vue&type=script&lang=js"
export * from "./Sub_DepartmentCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports